import React, { useMemo, useCallback } from 'react'
import styles from '../search/styles/search-results.module.scss'
import { Player, SortingDirection, SortingField, WatchlistSortingKeys } from 'types/global'
import { TABLET_BREAKPOINT } from 'constants/global'
import { useDispatch, useSelector } from 'react-redux'
import { setSorting } from 'actions/watchlist-actions'
import { AppState } from 'redux/reducers'
import SearchResultsTableDesktop from 'components/search/SearchResultsTableDesktop'
import SearchResultMobile from 'components/search/SearchResultMobile'
import useWindowSize from 'hooks/use-windowSize'
import SearchResult from 'components/search/SearchResultDesktop'
import WatchlistToggle from './WatchlistToggle'
import cx from 'classnames'

import { createSortPlayersFunc } from 'utils'
import { selectOwnTennisId } from 'redux/selectors'

interface Props {
  players: Player[]
}

const WatchlistPlayersTable = ({ players }: Props) => {
  const dispatch = useDispatch()
  const ownTennisId = useSelector(selectOwnTennisId)
  const sorting = useSelector((state: AppState) => state.watchlists.sorting.players)
  const sortedPlayers = useMemo(
    () => players.sort(createSortPlayersFunc(sorting)),
    [sorting, players]
  )
  const isDesktop = useWindowSize().width > TABLET_BREAKPOINT

  const handleSelectSorting = (field: SortingField) => {
    if (field === sorting.field) {
      dispatch(
        setSorting(
          {
            direction:
              sorting.direction === SortingDirection.ASC
                ? SortingDirection.DESC
                : SortingDirection.ASC,
            field: sorting.field,
          },
          WatchlistSortingKeys.PLAYERS
        )
      )
    } else {
      dispatch(setSorting({ direction: SortingDirection.ASC, field }, WatchlistSortingKeys.PLAYERS))
    }
  }

  const renderTableRow = useCallback(
    (p: Player) => {
      const showWatchlist = !!ownTennisId && p.tennisID !== ownTennisId
      return (
        <SearchResult key={p.id} player={p} withLink>
          <td className={styles.watchlistCell} aria-hidden={!showWatchlist}>
            {showWatchlist && <WatchlistToggle player={p} />}
          </td>
        </SearchResult>
      )
    },
    [ownTennisId]
  )

  return (
    <>
      {isDesktop ? (
        <div className={styles.searchResultsContent}>
          <SearchResultsTableDesktop
            players={sortedPlayers}
            sorting={sorting}
            handleSelectSorting={handleSelectSorting}
            renderTableRow={renderTableRow}
            classHiddenCell={styles.watchlistCell}
          />
        </div>
      ) : (
        <div className={cx(styles.searchResultsContentMobile, styles.mt28)}>
          <ul className={styles.searchResultsListMobile}>
            {sortedPlayers.map(p => (
              <li key={p.id}>
                <SearchResultMobile player={p} withWatchlistBadge={p.tennisID !== ownTennisId} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

export default WatchlistPlayersTable
